import { ca } from '@cian/analytics';

import type { IJsonQuery } from '../../repositories/common/json_query';
import type { IOffer } from 'shared/offer';

export function trackOfferClick(offerId: number, position: number): void {
  ca('eventSite', {
    name: 'oldevent',
    action: 'click_sopr',
    category: 'Listing',
    label: 'etazhi_black_friday_carousel_to_card',
    products: [
      {
        id: offerId,
        offerType: 'offer',
        position: position + 1,
      },
    ],
  });
}

export function trackEtazhiLogoClick(jsonQuery: IJsonQuery): void {
  ca('eventSite', {
    name: 'oldevent',
    action: 'click_sopr',
    category: 'Listing',
    label: 'etazhi_black_friday_carousel_to_company_card',
    sc: jsonQuery,
  });
}

export function trackEtazhiLinkButtonClick(jsonQuery: IJsonQuery): void {
  ca('eventSite', {
    name: 'oldevent',
    action: 'click_sopr',
    category: 'Listing',
    label: 'etazhi_black_friday_carousel_to_listing',
    sc: jsonQuery,
  });
}

export function trackEtazhiPromoOffersShown(jsonQuery: IJsonQuery, promoOffers: IOffer[], startIndex: number): void {
  ca('eventSite', {
    name: 'oldevent',
    action: 'show_sopr',
    category: 'Listing',
    label: 'etazhi_black_friday_carousel_view',
    sc: jsonQuery,
    products: promoOffers.map((offer, i) => ({ id: offer.id, offerType: 'offer', position: startIndex + i })),
  });
}
